import React, { useState } from "react";
import dayjs from "dayjs";
// import { Button, Card } from "antd";
import { Dayjs } from "dayjs";
import { Draggable } from "react-beautiful-dnd";
import { Card, CardDescription, CardTitle } from "../../components/ui/card";
import {
  AppointmentType,
  ColumnType,
} from "../Appointments/AppointmentsKanban/appointmentsConstants";
import { IAppointmentsDataType } from "../../redux/reduxAppointments/appointmentsSlice";
import "./kanban.css";
import { EditFilled } from "@ant-design/icons";
import { EditAppointmentModal } from "../Appointments/AppointmentsKanban/EditAppointmentModal";
import { Link } from "react-router-dom";
import {
  APPOINTMENT,
  CONSULTING,
  FOLLOW_UP,
  NO_CHARGE,
  PATIENT_PROFILE,
} from "../CONSTANTS";
import { Separator } from "../../components/ui/separator";
import { Button } from "../../components/ui/button";
import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { ConfirmDeletePopover } from "./ConfirmDeletePopover";
import { Badge } from "../../components/ui/badge";
export function Task({
  appointment,
  index,
}: {
  appointment: IAppointmentsDataType;
  index: number;
}) {
  const [modalData, setModalData] = useState();
  const [isDoctor, setIsDoctor] = useState(true);
  const [isEditOpen, setIsEditOpen] = useState(false);

  function getLink(
    firstName: string,
    lastName: string,
    patientId: string,
    patientPath: string,
    appointmentId: string,
    appointmentPath: string
  ) {
    return (
      <Link
        to={`${patientPath}${patientId}${appointmentPath}${appointmentId}`}
        target="_blank"
      >
        {firstName} {lastName}
      </Link>
    );
  }
  function OnEdit(appointment: IAppointmentsDataType) {
    setIsEditOpen(true);
  }
  function onDelete(appointment: IAppointmentsDataType) {
    console.log("Delete", appointment);
  }
  function colorByType(type: string) {
    switch (type) {
      case CONSULTING:
        return "bg-[#D0FFBC]";
      case FOLLOW_UP:
        return "bg-[#ffb38a]";
      case NO_CHARGE:
        return "bg-[#87CEEB]";
      default:
        return "bg-white";
    }
  }
  return (
    <div>
      <Draggable draggableId={appointment.id} index={index}>
        {(provided, snapshot) => (
          <Card
            className={`isolate aspect-auto my-2 rounded-sm ${colorByType(
              appointment.type
            )}
            shadow-xl ring-1 ring-black/5 `}
            // className="bg-white rounded-lg shadow-md overflow-hidden"
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            data-isdragging={snapshot.isDragging}
            ref={provided.innerRef}
          >
            <CardTitle className="tracking-tight relative">
              {isDoctor
                ? getLink(
                    appointment.firstName,
                    appointment.lastName,
                    appointment.patientId,
                    PATIENT_PROFILE,
                    appointment.id,
                    APPOINTMENT
                  )
                : `${appointment.firstName} ${appointment.lastName}`}
              <Button
                className="absolute right-0"
                variant="link"
                size="icon"
                onClick={() => OnEdit(appointment)}
              >
                <Pencil1Icon color="#254D26" />
              </Button>
              <ConfirmDeletePopover appointmentDetails={appointment} />
              {/* <Button
                variant="link"
                size="icon"
                className="absolute right-6 p-2"
                onClick={() => onDelete(appointment)}
              >
                <TrashIcon color="#E10B00" />
              </Button> */}
            </CardTitle>
            <Separator className=" my-2 bg-zinc-300" />
            <TaskBody appointment={appointment} />
          </Card>
          // <Card
          //   title={
          //     isDoctor
          //       ? getLink(
          //           appointment.firstName,
          //           appointment.lastName,
          //           appointment.patientId,
          //           PATIENT_PROFILE
          //         )
          //       : `${appointment.firstName} ${appointment.lastName}`
          //   }
          //   extra={
          //     <Button size="small" onClick={OnEdit} icon={<EditFilled />} />
          //   }
          //   bordered={false}
          //   style={{ width: 10, padding: 3 }}
          //   data-isdragging={snapshot.isDragging}
          //   ref={provided.innerRef}
          //   {...provided.draggableProps}
          //   {...provided.dragHandleProps}
          // >
          //   <TaskBody appointment={appointment} />
          // </Card>
        )}
      </Draggable>
      <EditAppointmentModal
        isEditOpen={isEditOpen}
        setIsEditOpen={setIsEditOpen}
        appointmentDetails={appointment}
      />
    </div>
  );
}

function TaskBody({ appointment }: { appointment: IAppointmentsDataType }) {
  var typeBadge = null;
  if (appointment.type === CONSULTING) {
    typeBadge = <Badge className="absolute right-0">C</Badge>;
  }
  if (appointment.type === FOLLOW_UP) {
    typeBadge = <Badge className="absolute right-0">F</Badge>;
  }
  if (appointment.type === NO_CHARGE) {
    typeBadge = <Badge className="absolute right-0">NC</Badge>;
  }
  switch (appointment.status) {
    case "HAS_APPOINTMENT":
      return (
        <div className="relative">
          {" "}
          <p>
            {`Appointment Start Time: ${dayjs(appointment.startDateTime).format(
              "h:mm a"
            )}`}
            {typeBadge}
          </p>
        </div>
      );
    case "ARRIVED":
      return (
        <div className="relative">
          <p>
            {`Arrived Time: ${dayjs(appointment.updatedAt).format("h:mm a")}`}
            {typeBadge}
          </p>
        </div>
      );
    case "IN_PROGRESS":
      return (
        <div className="relative">
          <p>
            {`In consulting Time: ${dayjs(appointment.updatedAt).format(
              "h:mm a"
            )}`}{" "}
            {typeBadge}
          </p>
        </div>
      );
    case "WAITING_FOR_XRAY":
      return (
        <div className="relative">
          <p>
            {`Time since waiting for X-Ray: ${dayjs(
              appointment.updatedAt
            ).format("h:mm a")}`}
            {typeBadge}
          </p>
        </div>
      );
    case "IN_XRAY":
      return (
        <div className="relative">
          <p>
            {`In X-Ray Time: ${dayjs(appointment.updatedAt).format("h:mm a")}`}
            {typeBadge}
          </p>
        </div>
      );
    case "DONE":
      return (
        <div className="relative">
          <p>
            {`Waiting for Payment Time: ${dayjs(appointment.updatedAt).format(
              "h:mm a"
            )}`}
            {typeBadge}
          </p>
        </div>
      );
    case "PAID":
      return (
        <div className="relative">
          <p>
            {`Time since Paid: ${dayjs(appointment.updatedAt).format(
              "h:mm a"
            )}`}
            {typeBadge}
          </p>
        </div>
      );

    default:
      return (
        <div className="relative">
          {" "}
          <p>
            {`Appointment Start Time: ${dayjs(appointment.startDateTime).format(
              "h:mm a"
            )}`}
          </p>
          <p>
            {`Appointment Last Updated Time: ${dayjs(
              appointment.updatedAt
            ).format("h:mm a")}`}
            {typeBadge}
          </p>
        </div>
      );
  }
}
